import React, { useEffect, useState } from "react";
import withAuth from "../../hocs/withAuth";
import withApp from "../../hocs/withApp";
import {
  Box,
  Button,
  Container,
  Grid2,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import SelectApiInput from "../../components/common/input/SelectApiInput";
import { asyncSearchList } from "../../utils/httpRequests";
import { useDispatch, useSelector } from "react-redux";
import { groupBy } from "../../utils/helpers";
import { isArray } from "lodash";
import { v4 } from "uuid";
import Logo from "../../components/common/layout/header/Logo";
import UserSetting from "../../components/common/layout/header/UserSetting";
import { LuHome } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { updateCurrentStore } from "../../redux/reducers/order.reducer";

const heights = {
  header: "50px",
};

function TablePage() {
  const token = useSelector((state: any) => state.auth.token);
  const app = useSelector((state: any) => state.app.data);
  const { currentStore } = useSelector((state: any) => state.order);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getTables = async () => {
    if (loading) return;
    setLoading(true);
    const resp = await asyncSearchList({
      apiCode: "dmban2",
      idApp: app?._id,
      token,
      condition: {
        page: 1,
        limit: 999999,
        q: { ma_kho: currentStore?.ma_kho },
      },
    });
    const result = groupBy({
      data: resp.data,
      callbackMatch: (item) => item.ten_nh_ban,
    });
    setData(result as any[]);
    setLoading(false);
  };

  const handleStoreChange = (value: any) => {
    dispatch(updateCurrentStore(value));
  };

  const handleSelectTable = (maBan: string) => {
    navigate(`/fnb/${currentStore?.ma_kho}/${maBan}`);
  };

  useEffect(() => {
    if (currentStore?.ma_kho) {
      getTables();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStore?.ma_kho]);

  return (
    <Stack
      gap={1}
      sx={{ minHeight: "100vh", backgroundColor: "background.default" }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: heights.header,
          px: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Logo />
        <UserSetting
          options={[
            { text: "Trang chủ", path: "/", Icon: LuHome },
            { text: "Danh sách công ty", path: "/app", Icon: LuHome },
          ]}
        />
      </Stack>
      <Container>
        <Stack
          sx={{
            height: "100%",
            p: 1,
          }}
          gap={1}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">Chọn bàn</Typography>
            <Box sx={{ width: "200px" }}>
              <SelectApiInput
                apiCode="dmkho"
                labelWidth="0%"
                placeholder="Chọn chi nhánh"
                wrapperSx={{
                  height: "35px",
                  backgroundColor: "background.paper",
                }}
                value={currentStore}
                onChange={handleStoreChange}
                searchFields={["ma_kho", "ten_kho"]}
                getOptionLabel={(option) => option.ten_kho}
                checkEqual={(val, option) => val?.ma_kho === option?.ma_kho}
              />
            </Box>
          </Stack>
          {loading ? (
            <>
              <Grid2 container spacing={2}>
                {new Array(4).fill(0).map((_, index) => {
                  return (
                    <Grid2 key={index} size={{ xs: 6, sm: 4, md: 3, lg: 2 }}>
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        sx={{ width: "100%", height: "50px" }}
                      />
                    </Grid2>
                  );
                })}
              </Grid2>
            </>
          ) : (
            <>
              {!currentStore ? (
                <Typography sx={{ textAlign: "center", fontSize: "18px" }}>
                  Chọn chi nhánh để xem bàn
                </Typography>
              ) : (
                <Stack gap={2}>
                  {isArray(data) && data.length > 0 ? (
                    <>
                      {data.map((tables) => {
                        return (
                          <Stack key={v4()} gap={1}>
                            <Typography sx={{ fontWeight: 500 }}>
                              {tables[0]?.ten_nh_ban || "Bàn chưa nhóm"}
                            </Typography>
                            <Grid2 container spacing={2}>
                              {tables.map((table: any) => {
                                let backgroundColor = "background.paper";
                                if (table.trang_thai === "1") {
                                  backgroundColor = "warning.main";
                                }
                                if (table.trang_thai === "2") {
                                }
                                return (
                                  <Grid2
                                    key={table._id}
                                    size={{ xs: 6, sm: 4, md: 3, lg: 2 }}
                                  >
                                    <Button
                                      onClick={() =>
                                        handleSelectTable(table.ma_ban)
                                      }
                                      disabled={table.trang_thai === "3"}
                                      variant="contained"
                                      sx={{
                                        width: "100%",
                                        boxShadow: "none",
                                        backgroundColor,
                                        textTransform: "none",
                                        fontWeight: 400,
                                        minHeight: "100px",
                                        "&:hover": {
                                          backgroundColor,
                                          boxShadow: "none",
                                        },
                                      }}
                                    >
                                      {table.ten_ban}
                                    </Button>
                                  </Grid2>
                                );
                              })}
                            </Grid2>
                          </Stack>
                        );
                      })}
                    </>
                  ) : (
                    <Typography sx={{ textAlign: "center" }}>
                      Chi nhánh '{currentStore?.ten_kho}' chưa có bàn
                    </Typography>
                  )}
                </Stack>
              )}
            </>
          )}
        </Stack>
      </Container>
    </Stack>
  );
}

export default withAuth(withApp(TablePage));
